import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AyPageMainComponent } from "@shared-ay/layouts/ay-page-main/ay-page-main.component";
import { AyPageComponent } from "@shared-ay/layouts/ay-page/ay-page.component";
import { AyPageTitleComponent } from "@shared-ay/layouts/ay-page-title/ay-page-title.component";
import { AyPageMainContentComponent } from "@shared-ay/layouts/ay-page-main-content/ay-page-main-content.component";
import { AyPageMainSideComponent } from "@shared-ay/layouts/ay-page-main-side/ay-page-main-side.component";

@NgModule({
	declarations: [
		AyPageMainComponent,
		AyPageComponent,
		AyPageTitleComponent,
		AyPageMainContentComponent,
		AyPageMainSideComponent,
	],
	imports: [CommonModule],
	exports: [
		AyPageMainComponent,
		AyPageComponent,
		AyPageTitleComponent,
		AyPageMainContentComponent,
		AyPageMainSideComponent,
	],
})
export class LayoutAyWebModule {}
